import React from 'react';
import PropTypes from 'prop-types';
import { Loading as GluLoading } from '@glu/indicators-react';
import classNames from 'classnames';
import { createUseStyles } from '@glu/theming';

const useStyles = createUseStyles(({
  loader
}) => ({
  loader
}));

const Loading = ({
  children,
  className,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <GluLoading
      data-qa="main-loader"
      className={classNames(classes.loader, className)}
      size={35}
      {...rest}
    >
      {children}
    </GluLoading>
  );
};

Loading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

Loading.defaultProps = {
  children: <span />,
  className: undefined
};

export default Loading;
